import React from 'react';
import {
  Flex,
  Box,
  Button,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Alert,
  AlertIcon,
  useToast,
  Link  // Added missing import
} from '@chakra-ui/react';
import { useAuth0 } from '@auth0/auth0-react';

const Logout = () => {
  const { logout, isAuthenticated, user } = useAuth0();
  const toast = useToast();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
    toast({
      title: 'Logged out successfully',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  if (!isAuthenticated) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg={bgColor}>
        <Box
          w="full"
          maxW="md"
          p={8}
          borderRadius="lg"
          boxShadow="lg"
          bg={cardBg}
          textAlign="center"
        >
          <Alert status="info" borderRadius="md" mb={4}>
            <AlertIcon />
            You have successfully logged out!
          </Alert>
          <Button 
            as="a" 
            href="/login" 
            colorScheme="blue" 
            width="full"
          >
            Go to Login
          </Button>
        </Box>
      </Flex>
    );
  }

  return (
    <Flex minH="100vh" align="center" justify="center" bg={bgColor}>
      <Box
        w="full"
        maxW="md"
        p={8}
        borderRadius="lg"
        boxShadow="lg"
        bg={cardBg}
      >
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading as="h1" size="xl" mb={2}>
              Ready to Leave?
            </Heading>
            <Text color="gray.500">
              {user?.name || user?.email} will be logged out
            </Text>
          </Box>

          <VStack spacing={4}>
            <Button
              onClick={handleLogout}
              colorScheme="red"
              size="lg"
              width="full"
            >
              Confirm Logout
            </Button>

            <Button 
              as="a" 
              href="/" 
              variant="outline" 
              width="full"
            >
              Cancel
            </Button>
          </VStack>

          <Text textAlign="center" color="gray.500" fontSize="sm">
            Changed your mind?{' '}
            <Link color="blue.500" href="/profile">
              Go to your profile
            </Link>
          </Text>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Logout;